module.exports = __webpack_public_path__ + "img/optimizing-dosing.5651c9d7.png";